import { render, staticRenderFns } from "./SystemPolicies.vue?vue&type=template&id=46b1ad9d&scoped=true&"
import script from "./SystemPolicies.vue?vue&type=script&lang=js&"
export * from "./SystemPolicies.vue?vue&type=script&lang=js&"
import style0 from "./SystemPolicies.vue?vue&type=style&index=0&id=46b1ad9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1ad9d",
  null
  
)

export default component.exports